import React from "react";
import { Phone, Mail, MapPin, Building2, Globe } from "lucide-react";
import Logo from "./Logo";
import { navLinks, company } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#0e2f5c] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <Logo light size="lg" />
            <p className="mt-5 text-white/70 leading-relaxed max-w-sm">
              Warm, reliable and person-centred NDIS support, delivered with
              genuine care right across Australia.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Quick links</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/70 hover:text-[#8ed06a] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Contact us</h4>
            <ul className="space-y-3.5">
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#8ed06a] shrink-0" />
                <a href={`tel:${company.phoneRaw}`} className="text-white/80 hover:text-white">
                  {company.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#8ed06a] shrink-0" />
                <a href={`mailto:${company.email}`} className="text-white/80 hover:text-white break-all">
                  {company.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Globe className="h-5 w-5 text-[#8ed06a] shrink-0" />
                <a href={company.websiteUrl} className="text-white/80 hover:text-white">
                  {company.website}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-5 w-5 text-[#8ed06a] shrink-0" />
                <span className="text-white/80">{company.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Building2 className="h-5 w-5 text-[#8ed06a] shrink-0" />
                <span className="text-white/80">ACN {company.acn}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/60 text-sm">
            &copy; {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <p className="text-white/60 text-sm">{company.fullName}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
